var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { palette } from '@/theme/palette';
import { typography } from '@/theme/typography';
import { createTheme } from '@mui/material';
export var iconConfig = {
    color: palette.primary.main,
    size: '2em',
};
export var theme = createTheme({
    palette: palette,
    breakpoints: {
        keys: ['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 426,
            md: 769,
            lg: 1025,
            xl: 1441,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: '8rem',
                    fontFamily: 'montserrat, sans-serif',
                    fontWeight: 'bold',
                    textTransform: 'none',
                },
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        borderRadius: '100px',
                        color: 'white',
                        '&&&:hover': {},
                        '&.Mui-selected': {},
                        '&.Mui-disabled': {
                            color: 'white',
                            backgroundColor: '#1E1D1Baa',
                        },
                    },
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        borderRadius: '100px',
                        // border: '2px solid black',
                        borderWidth: '2px',
                        // color: 'black',
                        '&&&:hover': {
                            borderWidth: '2px',
                        },
                        '&.Mui-selected': {},
                        '&.Mui-disabled': {
                            opacity: 0.25,
                        },
                    },
                },
            ],
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontFamily: 'montserrat, sans-serif',
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    display: 'flex',
                    alignItems: 'center',
                    marginInline: '0',
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: palette.primary.main,
                },
            },
        },
        MuiFab: {
            styleOverrides: {},
            variants: [
                {
                    props: { variant: 'keypad' },
                    style: {
                        color: palette.primary.main,
                        borderColor: palette.primary.main,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        backgroundColor: 'white',
                        boxShadow: '0px 3px 5px -1px rgb(0 0 0 / 5%), 0px 6px 10px 0px rgb(0 0 0 / 5%), 0px 1px 18px 0px rgb(0 0 0 / 5%)',
                        '&&&:hover': {
                            backgroundColor: '#fefefe',
                        },
                        '&&&:disabled': {
                            color: 'white',
                            backgroundColor: palette.secondary.main,
                        },
                        '&&&.active': {
                            backgroundColor: palette.primary.main,
                            color: palette.common.white,
                        },
                        '&&': {
                            fontSize: '1.75rem',
                            fontWeight: '800',
                        },
                        '&&&.HxKeypad-clear': {
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                        },
                    },
                },
            ],
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: palette.primary.main,
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    height: '48px',
                    width: '100px',
                    '&&& .Mui-checked': {
                        transform: 'translateX(35px)',
                    },
                },
                track: {
                    height: '40px',
                    position: 'relative',
                    top: '-5px',
                    borderRadius: '999px',
                    width: '100px',
                },
                thumb: {
                    position: 'relative',
                    left: '5px',
                    height: '36px',
                    width: '36px',
                },
            },
        },
        MuiTypography: __assign(__assign({}, typography), { defaultProps: {
                variantMapping: {
                    h1: 'h1',
                    h2: 'h2',
                    h3: 'h2',
                    h4: 'h2',
                    h5: 'h2',
                    h6: 'h2',
                    subtitle1: 'h2',
                    subtitle2: 'h2',
                    body1: 'span',
                    body2: 'span',
                },
            } }),
    },
});
